import * as React from 'react';
import { connect } from 'react-redux';
import { navigate } from '~/router';

import { createPaycode, getOrgPaycodes } from '../../actions/paycodes';
import { SearchableModelHelper } from '~/lib/forms/select';
import { OrganizationType } from '~/apps/shared/consts';
import { createOrganizationHelper } from '~/apps/shared/services/forms';
import { getPaycodeFilter } from '../../services/qsfilters';

import PaycodeFormOverlay from '../../components/codes/PaycodeFormOverlay';
import Loader from '~/common/components/Loader';
import { defaultTablePageSize } from '~/common/components/consts';


class CreatePaycodePopup extends React.Component<any, any> {
  orgHelper: SearchableModelHelper;
  locationHelper: SearchableModelHelper;

  constructor(props) {
    super(props);

    this.orgHelper = createOrganizationHelper(this.refresh, this.getOrgById, null, OrganizationType.UNLOADER);
  }

  refresh = () => {
    this.forceUpdate();
  };

  getOrgById = (orgId: string) => {
    return this.props.organizations.entities[orgId];
  };

  onSubmit = (data) => {
    const { dispatch, auth } = this.props;
    const orgId = auth.currentUser.organizationId;

    return dispatch(createPaycode(orgId, data))
      .then((res) => {
        dispatch(getOrgPaycodes(orgId, null, 0, defaultTablePageSize));
        navigate('sender.paycodes.confirm', { paycodeId: res.result });
      });
  };

  onClose = () => {
    navigate('sender.paycodes');
  };

  render() {
    const { errorMessage, loading } = this.props;

    if (loading) {
      // TODO:
      return (
        <Loader className="load--ol"/>
      );
    }

    return (
      <PaycodeFormOverlay
        headTitle="New Payment"
        onSubmit={this.onSubmit}
        onClose={this.onClose}
        organizations={this.orgHelper}
        errorMessage={errorMessage}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.shared.auth,
    errorMessage: state.sender.paycodes.ui.errorMessage,
    loading: state.sender.paycodes.ui.loading,
    organizations: state.shared.organizations,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreatePaycodePopup) as any;
